import type { IconSvgObject } from './types';

const KettleIcon: IconSvgObject = [
  ["path", { d: "M4 21H16C17.1046 21 18 20.1046 18 19L18 17C18 12.5817 14.4183 9 10 9C5.58172 9 2 12.5817 2 17V19C2 20.1046 2.89543 21 4 21Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 9V8C8 6.89543 8.89543 6 10 6C11.1046 6 12 6.89543 12 8V9", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M18 17C19.2624 17 20.5 16.1046 20.5 15V12.5C20.5 11.6716 21.1716 11 22 11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M16 11.5V9C16 5.68629 13.3137 3 10 3C6.68629 3 4 5.68629 4 9V11.5", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M2 17H12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default KettleIcon;
